$("body").on("change","#dublicate_Quantity .quantity__input",function(){
  var thisVl = $(this).val();
  $(".product__info-container .quantity__input").val(thisVl);
});





// Create a MutationObserver instance
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      // Check if the price element is now in the DOM
      const priceElement = document.querySelector('.product__info-container .price');
      if (priceElement) {
        $("pricearea").html($(".product__info-container .price").clone());
        console.log('Price element has loaded.');
        // Stop observing if you no longer need to
        observer.disconnect();
      }
    }
  });
});

// Start observing the document body or a specific container
observer.observe(document.body, { childList: true, subtree: true });






$("a.Vehicle").click(function(e){
 e.preventDefault();        
 $(".gbox-portal.bike").toggleClass("flex");  
});
  
$(".gbox-close").click(function(e){
 e.preventDefault();        
 $(".gbox-portal.bike").removeClass("flex");  
});
  
  
  $(".select-vehicle-col .main-selector").click(function(){
  $(".select-vehicle-col .main-selector").not($(this)).removeClass("-open");
  $(this).toggleClass("-open");
});
  $("body").on("click",".select-vehicle-col .main-selector ul.list>li",function(e){
e.stopPropagation();
 var thisEl = $(this);
    thisEl.closest(".main-selector").find("ul.list>li").removeClass("-active");
    thisEl.addClass("-active");
  //  $(".aside-slct-load.-rounded").addClass("block");
  setTimeout(function(){
   // $(".aside-slct-load.-rounded").removeClass("block");
    //console.log(thisEl.text());
   thisEl.closest(".main-selector").removeClass("-open").attr("data-placeholder",thisEl.text());
                       updateAll();
                       },500);
});
  

			window.shopUrl = 'https://www.air-flowseatcovers.com';
			window.routes = {
				cart_add_url: '/cart/add',
				cart_change_url: '/cart/change',
				cart_update_url: '/cart/update',
				cart_url: '/cart',
				predictive_search_url: '/search/suggest',
			};
			window.cartStrings = {
				error: `There was an error while updating your cart. Please try again.`,
				quantityError: `You can only add [quantity] of this item to your cart.`,
			};
			window.variantStrings = {
				addToCart: `Add to cart`,
				soldOut: `Sold out`,
				unavailable: `Unavailable`,
				unavailable_with_option: `[value] - Unavailable`,
			};
			window.quickOrderListStrings = {
				itemsAdded: `[quantity] items added`,
				itemAdded: `[quantity] item added`,
				itemsRemoved: `[quantity] items removed`,
				itemRemoved: `[quantity] item removed`,
				viewCart: `View cart`,
				each: `[money]/ea`,
			};
			window.accessibilityStrings = {
				imageAvailable: `Image [index] is now available in gallery view`,
				shareSuccess: `Link copied to clipboard`,
				pauseSlideshow: `Pause slideshow`,
				playSlideshow: `Play slideshow`,
				recipientFormExpanded: `Gift card recipient form expanded`,
				recipientFormCollapsed: `Gift card recipient form collapsed`,
			};

   
		
	let ShipmentDate = "DEC,17,2022";

	let bikes = {};
	let stock = {};
	let yearEl = document.querySelector('#vehiclemadeYear');
	let makeEl = document.querySelector('#vehicleBrand');
	let modelEl = document.querySelector('#vehicleModel');
	let bikeBrief = document.querySelector('#selectedBikeData textarea');
	let notifyBtn = document.querySelector('#SI_trigger');

	let orderBtn = document.querySelector('#AddToCart--product-template');
	let selectBtn = document.querySelector('.red-color-btn');
    
	
	//let originalVariantSelector = document.querySelector('#SingleOptionSelector-0');

	resetBtns();

	async function updateAll() {
		let year = yearEl.dataset.placeholder; 
		let make = makeEl.dataset.placeholder; if (typeof make !== 'undefined' && make !== null) { make = make.toUpperCase();} 
		let model = modelEl.dataset.placeholder; if (typeof model !== 'undefined' && model !== null) { model = model.toUpperCase();} 

		await loadData(); // make sure data is loaded.

		if (year && make) {
			setModels(parseInt(year), make, model);
		}
	}

	const _getJSON = async (url, isJson = true) => {
		const response = await fetch(url);
		if (!response.ok) throw new Error(response.statusText);

		const data = await (isJson ? response.json() : response.text());
		return data;
	}

	async function loadData() {
		if (Object.keys(bikes).length > 0 && Object.keys(stock).length > 0) return; // data loaded, nothing to do

		try {
          // Get the element by its ID
var elem = document.getElementById('Select_Vehicle');

// Check if the element exists to avoid errors
if (elem) {
  // Get the value of the data-mf attribute
  var mfValue = elem.getAttribute('mf');
if(mfValue && mfValue.includes('Motorcycle')){
            bikes = await _getJSON(`//www.air-flowseatcovers.com/cdn/shop/t/1/assets/motolist.json?v=141093349424329655541752336216`);
}
  else{
     bikes = await _getJSON(`//www.air-flowseatcovers.com/cdn/shop/t/1/assets/golflist.json?v=91720693401104572011726074084`);
  }
  
  
}
          
		} catch (error) {
			console.error("Error loading bike list:", error);
		}

		// try {
		// 	let data = await _getJSON("https://windriderseatcovers.com/products/air/checkstock", false);
		// 	let div = document.createElement('div');
		// 	div.innerHTML = data;
		// 	stock = JSON.parse(div.innerText.trim());
		// } catch (error) {
		// 	console.error("Error loading stock data:", error);
		// }
	}

	function getModels(year, make) {
		let res = []; 
      if (typeof make !== 'undefined' && make !== null) { make = make.toUpperCase();}
		Object.keys(bikes).forEach(size => {
			if (!bikes[size][make]) return;
			let models = Object.keys(bikes[size][make]);
			models.forEach(modelKey => {
				if (bikes[size][make][modelKey].includes(year))
					if (!res.includes(modelKey))
						res.push(modelKey);
			});
		});
		res.sort((a, b) => a.localeCompare(b));
		return res;
	}

	function getSize(year, make, model) {
		if (!model) return '';
		let sizes = Object.keys(bikes);
		for (let i in sizes) {
			let size = sizes[i];
			if (!bikes[size]) continue;
			if (!bikes[size][make]) continue;
			if (!bikes[size][make][model]) continue;
			if (bikes[size][make][model].includes(year)) return size;
		};
		return '';
	}

	function setModels(year, make, model) {
      
		let models = getModels(year, make);

		modelEl.getElementsByClassName("list")[0].innerHTML = '<li class="item "></li>';
		if (models.length > 0) {
			models.forEach(m => {
				let opt = document.createElement('li');
              opt.classList.add('item');
				//opt.value = m;
              if (typeof m !== 'undefined' && m !== null) { m = m.toUpperCase();} 
				opt.innerText = m;
				if (m === model) opt.classList.add('-active'); //opt.selected = true;
				modelEl.getElementsByClassName("list")[0].appendChild(opt);
			});

			let size = getSize(year, make, model);

			//originalVariantSelector.value = size;
			//originalVariantSelector.dispatchEvent(new Event("change"));

			if (year && make && model && size) {
				bikeBrief.value = `Size: ${size} For: ${year} - ${make} - ${model}`;
              let shopifyAttribure = document.querySelector('.gvsselections');
				shopifyAttribure.value = `Size: ${size} For: ${year} - ${make} - ${model}`;

				jQuery("variant-selects .product-form__input input").each(function () {
					var option_value = jQuery.trim(jQuery(this).val());
                   if (typeof option_value !== 'undefined' && option_value !== null) { option_value = option_value.toUpperCase();} 
					if (option_value===size) {
                      $(this).next("label").addClass("gggg");
                          $(this).next("label").trigger("click");
					} else {
					
					}
				});

				size = size.replace(/\s/g, "-");
				if (!stock[size] || stock[size] < 1) {
					// localStorage.setItem("detail_string", "size=" + size + "&forbike=" + bikeBrief.value + ` (Pre-Order ${ShipmentDate})`);
					// shopifyAttribure.value = bikeBrief.value + ` (Pre-Order ${ShipmentDate})`;
					// bikeBrief.value = bikeBrief.value + ` (Pre-Order ${ShipmentDate})`;
                    let shopifyAttribure = document.querySelector('.gvsselections');
                  localStorage.setItem("detail_string", "size=" + size + "&forbike=" + bikeBrief.value );
					shopifyAttribure.value = bikeBrief.value ;
					bikeBrief.value = bikeBrief.value ;
                    if(notifyBtn != null ){
    					notifyBtn.classList.remove('hidden');
                    }
				} else {
                    if(notifyBtn != null ){
    					notifyBtn.classList.add('hidden');
                    }
					localStorage.setItem("detail_string", "size=" + size + "&forbike=" + bikeBrief.value);
				}
               
              selectBtn.classList.add('hidden'); document.querySelector('product-info').classList.add('active');
              $(".aside-slct-load.-rounded").addClass("block");
              setTimeout(function(){
              $("pricearea").html($(".product__info-container .price").clone());
              },100);
              setTimeout(function(){
              $("pricearea").html($(".product__info-container .price").clone());
              },500);
              setTimeout(function(){
              $("pricearea").html($(".product__info-container .price").clone());
                $(".aside-slct-load.-rounded").removeClass("block");
              },1000);
              
               
			} else {
              $(".aside-slct-load.-rounded").removeClass("block");
              selectBtn.classList.remove('hidden'); document.querySelector('product-info').classList.remove('active');
				resetBtns();
			}
		} else {
			resetBtns();
		}
	}

	function resetBtns() {
        modelEl.setAttribute("data-placeholder","MODEL");
		bikeBrief.value = '';
      let shopifyAttribure = document.querySelector('.gvsselections');
       if(shopifyAttribure != null ){
		shopifyAttribure.value = '';
       }
        if(notifyBtn != null ){
    		notifyBtn.classList.add('hidden');
        }
	}

	function resetContent() {
		bikeBrief.style.pointerEvents = "none";
	}

	setTimeout(resetContent, 2000);
	window.onbeforeunload = function (event) {
		jQuery('#bikemadeYear').prop('selectedIndex', 0);
		jQuery('#madeBrand').prop('selectedIndex', 0);
		jQuery('#madeModel').prop('selectedIndex', 0);
		jQuery('#selectedBikeData textarea').val("");
	};
